import api from '../utils/API';
import { API_URLS } from '../constants/api_urls';

// 1 - cache
// 2 - unlisted
// 3  - listed
export class InstrumentsService {
  static async getAllInstruments(data) {
    const { limit, offset = 0, type } = data;
    const display_type = type === 'cashes-only'
      ? 1
      : type === 'without-cashes'
        ? 3
        : null;
    return await api.get(API_URLS.ALL_INSTRUMENTS, {
        params: { limit, offset, order: 'DESC', display_type },
      });
  }

  static async getInstrumentsTBD(data) {
    return await api.get(API_URLS.INSTRUMENTS_TBD, {
      params: {
        limit: data.limit,
        offset: data.offset,
        status: 'ASSET_REQUEST_STATUS_NEW',
        order: 'DESC',
      },
    });
  }

  static async getAssetsAll() {
    return await api.get(API_URLS.ASSETS);
  }

  static async getCategoriesAll() {
    return await api.get(API_URLS.ASSETS_CATEGORIES);
  }

  static async updateAsset(data) {
    return await api.put(`${API_URLS.UPDATE_ASSETS}/${data.ID}`, data.asset);
  }

  static async instrumentUpdate(values) {
    const { id, data } = values;
    return await api.put(`${API_URLS.UPDATE_INSTRUMENT}/${id}`, data);
  }

  static async create(data) {
    return await api.post(API_URLS.CREATE_INSTRUMENT, data);
  }

  static async delete(id) {
    return await api.delete(`${API_URLS.UPDATE_INSTRUMENT}/${id}`);
  }

  static async requestAsset(data) {
    const { id, ...rest } = data;
    return await api.put(`${API_URLS.INSTRUMENTS_TBD}/${id}/resolve`, {
      ...rest,
    });
  }

  static async createAssetClass(data) {
    return await api.post(`${API_URLS.CREATE_ASSET_CLASS}`, data);
  }

  static async deleteAssetClass(id) {
    return await api.delete(`${API_URLS.CREATE_ASSET_CLASS}/${id}`);
  }

  static async updateAssetClass(data) {
    const { id, ...rest } = data;
    return await api.put(`${API_URLS.CREATE_ASSET_CLASS}/${id}`, {
      ...rest,
    });
  }

  static async deleteRequest(id) {
    return await api.delete(`${API_URLS.INSTRUMENTS_TBD}/${id}`);
  }

  static async getCurrency() {
    return await api.get(API_URLS.GET_CURRENCY);
  }

  static async getDiversification() {
    return await api.get(API_URLS.GET_DIVERSIFICATION);
  }

  static async createModel(data) {
    return await api.post(API_URLS.MODEL_V3, data);
  }

  static async getModelById(id) {
    return await api.get(`${API_URLS.MODEL_V3}/${id}`);
  }

  static async getModelList() {
    return await api.get(API_URLS.MODEL_V3);
  }

  static async setModelDate({id, date}) {
    return await api.patch(`${API_URLS.MODEL_V3}/${id}/series`, date);
  }

  static async setStatusModel(data) {
    const {id, status} = data;
    return await api.post(`${API_URLS.MODEL_V3}/${id}/status/${status}`);
  }

  static async deleteNotActiveModel(id) {
    return await api.delete(`${API_URLS.MODEL_V3}/${id}`);
  }

  static async setModelSeries({id, seriesSetId, data}) {
    return await api.put(`${API_URLS.MODEL_V3}/${id}/seriesset/${seriesSetId}`, data);
  }

  static async getModelSeries({id, seriesSetId}) {
    return await api.get(`${API_URLS.MODEL_V3}/${id}/seriesset/${seriesSetId}`);
  }

  static async getModelPrimitives(id) {
    return await api.get(`${API_URLS.MODEL_V3}/${id}/primitives`);
  }

  static async setModelPrimitives(data) {
    const { id, ...rest } = data;
    return await api.patch(`${API_URLS.MODEL_V3}/${id}/primitives`, rest.data);
  }

  static async getModelLabel(id) {
    return await api.get(`${API_URLS.MODEL_V3}/${id}/labels`);
  }

  static async createModelLabel(data) {
    return await api.post('/v3/labels', {...data});
  }

  static async deleteModelLabel(id) {
    return await api.delete(`/v3/labels/${id}`);
  }

  static async updateModelLabel(data) {
    const { id } = data;
    return await api.put(`/v3/labels/${id}`, {...data});
  }

  static async uploadModelSeries(payload) {
    const {id, file} = payload;
    const bodyFormData = new FormData();
    bodyFormData.append('file', file);
    return await api.post(`${API_URLS.MODEL_V3}/${id}/seriesset-import`, bodyFormData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  static async uploadModelPrimitives(payload) {
    const {id, file} = payload;
    const bodyFormData = new FormData();
    bodyFormData.append('file', file);
    return await api.post(`${API_URLS.MODEL_V3}/${id}/primitives-import`, bodyFormData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }
  
  static async getModelConstraints(id) {
    return await api.get(`${API_URLS.MODEL_V3}/${id}/constraints`);
  }
  
  static async setModelConstraints(payload) {
    const {id, data} = payload;
    return await api.put(`${API_URLS.MODEL_V3}/${id}/constraints`, {...data});
  }
  
  static async tempDownloadConstraints(payload) {
    const {id, data} = payload;
    return await api.put(`${API_URLS.MODEL_V3}/${id}/seriesset-template`, {...data}, { responseType: 'arraybuffer' });
  }
  
  static async tempDownloadPrimitives(payload) {
    const {id} = payload;
    return await api.get(`${API_URLS.MODEL_V3}/${id}/primitives-template`,{ responseType: 'arraybuffer' });
  }
  
  static async getRecommendationMaps() {
    return await api.get(`${API_URLS.RECOMENDATION_MAPS}`);
  }
  
  static async getRecommendationMapById(id) {
    return await api.get(`${API_URLS.RECOMENDATION_MAPS}/${id}`);
  }
  
  static async createRecommendationMaps(data) {
    return await api.post(`${API_URLS.RECOMENDATION_MAPS}`, data);
  }
  
  static async updateRecommendationMaps(payloud) {
    const {mapsId, data} = payloud;
    return await api.put(`${API_URLS.RECOMENDATION_MAPS}/${mapsId}`, data);
  }
  
  static async deleteRecommendationMaps(id) {
    return await api.delete(`${API_URLS.RECOMENDATION_MAPS}/${id}`);
  }
  
  static async setModelDefault(id) {
    return await api.post(`${API_URLS.MODEL_V3}/${id}/default`);
  }
  
  static async updateMapsInfo(payloud) {
    const {id, data} = payloud;
    return await api.put(`${API_URLS.MODEL_V3}/${id}`, data);
  }
}
